import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import { loadRecaptcha } from '@/lib/recaptcha';
import './index.css';

// Boot reCAPTCHA v3 invisibly so a token is ready by the time the visitor
// reaches a form. Falls back to a no-op when VITE_RECAPTCHA_SITE_KEY is unset.
loadRecaptcha().catch((err) => console.warn('reCAPTCHA failed to load', err));

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
});

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
